module.exports = __webpack_public_path__ + "static/img/pay_connect.ba06d6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pay_connect.png
// module id = Xx/u
// module chunks = 8